import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid2,
  Button,
  TextField,
  FormControl,
  Stack,
  Select,
  MenuItem,
} from "@mui/material";
import { useFormik } from "formik";
import AlertMessage from "../../components/common/AlertMessage";
import "../../styles/LoginPage.css";
import { useLocation, useNavigate } from "react-router-dom";
import {formatPhoneNumber, getDropdownCity, getDropdownState, getDropdownZipCode, loginVariableSetting, setStorageValue} from "../../utils/helper"
import loginAPIMethod from "../../utils/services/login.api";
import Loaders from "../../components/common/Loaders";
import { completeProfileSchema } from "../../utils/schema/completeProfileSchema";
import { useAuth } from "../../utils/AuthContext";
import NotificationsListAPI from "../../utils/services/notifications.api";

function CompleteMobileProfile() {
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState("");
    const [cities, setCities] = useState([]);
    const { login } = useAuth();
    const [states, setStates] = useState([]);
    const [zipCodes, setZipCodes] = useState([]);
    const [loading, setLoading] = useState(false);
    const { createNormalUserProfile } = loginAPIMethod;
    const { checkUnreadNotifications } = NotificationsListAPI;
    const [stateSearchTerm, setStateSearchTerm] = useState("");
    const [citySearchTerm, setCitySearchTerm] = useState("");
    const [zipcodeSearchTerm, setZipcodeSearchTerm] = useState("");
    const handleClose = () => {
        setOpen(false);
    };

    const getUnreadNotification = async (userId) => {
        const checkDate = new Date()?.toISOString();
        const response = await checkUnreadNotifications(userId, checkDate);
        if (response.status !== "success") {
          localStorage.setItem("notifications", false);
        } else {
          if (localStorage.getItem("isClicked") !== "true") {
            localStorage.setItem("notifications", response?.data?.message);
            localStorage.setItem("isReload", response?.data?.message);
          }
        }
    };

    const formik = useFormik({
        initialValues: {
            countryCode: "+1",
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: location?.state?.phoneNumber,
            street: "",
            city: "",
            state: "",
            zipCode: "",
        },
        validationSchema: completeProfileSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const userCreationRequest = {
                countryCode: "+1",
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email,
                phoneNumber: location?.state?.phoneNumber,
                address: {
                    street: values.street,
                    city: values.city,
                    state: values.state,
                    zipCode: values.zipCode,
                }
            }
            const response = await createNormalUserProfile(userCreationRequest);
            if (response.status === "success") {
                setLoading(false);
                setMessage("Profile Created Successfully");
                setSeverity("success");
                setOpen(true);
                loginVariableSetting(response?.data);
                getUnreadNotification(response.data.id);
                setStorageValue("menuName", "My Delivery");
                login();
                setTimeout(() => {
                    navigate("/MyDelivery");
                }, 2000);
            } else if (response.status === "error") {
                setLoading(false);
                setMessage(response.message);
                setSeverity(response.status);
                setOpen(true);
            }
        },
    });

      
    useEffect(() => {
        if (formik?.isSubmitting && !formik?.isValidating) {
          let keys = Object.keys(formik?.errors);
          if (keys.length > 0) {
            const selector = `[name=${keys[0]}]`;
            const errorElement = document.querySelector(selector);
            if (errorElement) {
              errorElement.focus();
            }
          }
        }
    }, [formik.errors, formik.isSubmitting, formik.isValidating]);

    useEffect(() => {
        setdropdownState();
        if (formik.values.state && formik.values.city && formik.values.zipCode) {
          setdropdownCity(formik.values.state);
          setdropdownZipcode(formik.values.state, formik.values.city);
        }
        // eslint-disable-next-line
    }, [formik.values.city]);
    
    const setdropdownState = async () => {
        const response = await getDropdownState();
        setStates(response.data?.state);
    };
    
    const setdropdownCity = async (state) => {
        const response = await getDropdownCity(state);
        setCities(response.data?.city);
        if (response.data?.city.length === 1) {
            formik.handleChange({
                target: { name: "city", value: response.data?.city[0] },
            });
            setdropdownZipcode(state, response.data?.city[0]);
        }
    };
    
    const setdropdownZipcode = async (state, city) => {
        const result = await getDropdownZipCode(state, city);
        formik.setFieldTouched("zipCode", false);
        setZipCodes(result?.data?.zipCode);
        if (result?.data?.zipCode?.length === 1) {
            formik.handleChange({
                target: { name: "zipCode", value: result?.data?.zipCode[0] },
            });
        }
    };

    const handleStateSearchChange = (event) => {
        setStateSearchTerm(
            event.target.value?.replace(/[^a-zA-Z ]+/gi, "")?.replace(/\s\s+/g, " ")?.trimStart()
        );
    };


    const handleZipcodeSearchChange = (event) => {
        setZipcodeSearchTerm(event.target.value?.replace(/\s\s+/g, ' ')?.replace(/[^0-9]+/ig, ""));
    };

    const filteredZipcodes = zipCodes?.filter((zipValue) =>
        zipValue?.toLowerCase().startsWith(zipcodeSearchTerm?.toLowerCase())
    );

    const filteredStates = states?.filter(
    (state) =>
        state.state.toLowerCase().startsWith(stateSearchTerm.toLowerCase()) ||
        state.stateCode.toLowerCase().startsWith(stateSearchTerm.toLowerCase())
    );

    const handleCitySearchChange = (event) => {
        formik.setFieldTouched("zipCode", false);
        setCitySearchTerm(
            event.target.value?.replace(/[^a-zA-Z ]+/gi, "")?.replace(/\s\s+/g, " ")?.trimStart()
        );
    };

    const filteredCities = cities?.filter((city) =>
        city.toLowerCase().startsWith(citySearchTerm.toLowerCase())
    );

    const handleStateChange = (state) => {
        formik.setFieldTouched("state", false);
        formik.handleChange({
            target: { name: "city", value: "" },
        });
        formik.handleChange({
            target: { name: "zipCode", value: "" },
        });
        setdropdownCity(state);
    };

    const handleCityChange = (state, city) => {
        formik.setFieldTouched("zipCode", false);
        formik.handleChange({
            target: { name: "zipCode", value: "" },
        });
        setdropdownZipcode(state, city);
    };

    return(
        <Stack className="bg">
            {loading && (
                <Loaders />
            )}
            <Grid2>
                <img
                    src={require("../../assets/images/login_illustration.png")}
                    className="img2"
                    alt="img2"
                    onDragStart={(e) => {
                        e.preventDefault();
                    }}
                />
                <Box component="form" onSubmit={formik.handleSubmit} className="box-element">
                    <Box sx={{ display: "grid", width: "100%", padding: "2rem" }}>
                        <Box sx={{ paddingBottom: "6rem" }}>
                            <img
                                src={require("../../assets/logos/a2b-logo.svg").default}
                                alt="a2bLogoImage"
                                style={{ position: "absolute" }}
                                width="82%"
                                height="60px"
                                onDragStart={(e) => {
                                    e.preventDefault();
                                }}
                            />
                        </Box>
                        <Typography
                            sx={{ color: "#0C68F4", fontSize: "25px", fontWeight: "600" }}
                            variant="h5"
                            >
                            Complete your profile
                        </Typography>
                        <Box sx={{marginTop: "1rem", overflowY: "scroll", height: "270px", marginBottom: "1rem", paddingRight: "12px"}}>
                            <Grid2 spacing={2} size={{ xs: 12 }} sx={{ display: "flex", gap: 2 }}>
                                <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }} sx={{width: "100% !important"}}>
                                    <Typography
                                        className="form-label required"
                                        sx={{
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            fontFamily: "poppins!important",
                                        }}
                                    >
                                        Full name
                                    </Typography>
                                    <TextField
                                        sx={{
                                            "& .MuiInputBase-input.Mui-disabled": {
                                                WebkitTextFillColor: "#000000",
                                            },
                                        }}
                                        fullWidth
                                        name="firstName"
                                        autoComplete="off"
                                        placeholder="Enter First Name"
                                        value={formik.values.firstName}
                                        disabled={severity === "success"}
                                        error={ formik.touched.firstName && formik.errors.firstName }
                                        slotProps={{htmlInput: {maxLength: 50}}}
                                        onChange={(e) =>
                                            formik.handleChange({
                                                target: {
                                                    name: "firstName",
                                                    value: e?.target?.value?.replace(/[^a-zA-Z ’]/g, "")?.replace(/\s\s+/g, " ")?.trimStart(),
                                                },
                                            })
                                        }
                                        variant="outlined"
                                        size="small"
                                    />
                                    {formik.touched.firstName && formik.errors.firstName && (
                                        <div style={{ color: "#F04438" }}>{formik.errors.firstName}</div>
                                    )}
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }} sx={{marginTop: "21px", width: "100% !important"}}>
                                    <TextField
                                        sx={{
                                            "& .MuiInputBase-input.Mui-disabled": {
                                                WebkitTextFillColor: "#000000",
                                            },
                                        }}
                                        fullWidth
                                        name="lastName"
                                        autoComplete="off"
                                        placeholder="Enter Last Name"
                                        value={formik.values.lastName}
                                        disabled={severity === "success"}
                                        slotProps={{htmlInput: {maxLength: 50}}}
                                        error={ formik.touched.lastName && formik.errors.lastName }
                                        onChange={(e) =>
                                            formik.handleChange({
                                                target: {
                                                    name: "lastName",
                                                    value: e?.target?.value?.replace(/[^a-zA-Z ’]/g, "")?.replace(/\s\s+/g, " ")?.trimStart(),
                                                },
                                            })
                                        }
                                        variant="outlined"
                                        size="small"
                                    />
                                    {formik.touched.lastName && formik.errors.lastName && (
                                        <div style={{ color: "#F04438" }}>{formik.errors.lastName}</div>
                                    )}
                                </Grid2>
                            </Grid2>
                            <Grid2 sx={{marginTop: "1rem"}}>
                                <Typography
                                    className="form-label required"
                                    sx={{
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        fontFamily: "poppins!important",
                                    }}
                                >
                                    Email ID
                                </Typography>
                                <TextField
                                    sx={{
                                        "& .MuiInputBase-input.Mui-disabled": {
                                            WebkitTextFillColor: "#000000",
                                        },
                                    }}
                                    fullWidth
                                    type="text"
                                    name="email"
                                    autoComplete="off"
                                    placeholder="Enter Email ID"
                                    value={formik.values.email}
                                    disabled={severity === "success"}
                                    slotProps={{ htmlInput: {maxLength: 55}}}
                                    onChange={(e) =>
                                        formik.handleChange({
                                            target: {
                                                name: "email",
                                                value: e?.target?.value?.replace(/[^_a-zA-Z0-9!#$@%&'*+-/=?^_`{|}~;]/g, "")?.replace(/\s\s+/g, "")?.trimStart(),
                                            },
                                        })
                                    }
                                    error={ formik.touched.email && formik.errors.email }
                                    variant="outlined"
                                    size="small"
                                />
                                {formik.touched.email && formik.errors.email && (
                                    <div style={{ color: "#F04438" }}>{formik.errors.email}</div>
                                )}
                            </Grid2>
                            <Grid2 sx={{marginTop: "1rem"}}>
                                <Typography
                                    sx={{
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        fontFamily: "poppins!important",
                                    }}
                                    >
                                    Phone number
                                </Typography>
                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <TextField
                                        sx={{ 
                                            ".MuiOutlinedInput-root": {
                                                borderRadius: "10px",
                                                backgroundColor: "#F3F4F4",
                                            }, 
                                            "& .MuiInputBase-input.Mui-disabled": {
                                                WebkitTextFillColor: "#000000",
                                            },
                                            input: { cursor: "pointer" }
                                        }}
                                        variant="outlined"
                                        size="small"
                                        type="text"
                                        disabled
                                        value="+1"
                                        className="country-code"
                                    />
                                    <TextField
                                        sx={{ 
                                            ".MuiOutlinedInput-root": {
                                                borderRadius: "10px",
                                                backgroundColor: "#F3F4F4"
                                            }, 
                                            "& .MuiInputBase-input.Mui-disabled": {
                                                WebkitTextFillColor: "#000000",
                                            },
                                            input: { cursor: "pointer" }
                                        }}
                                        name="phoneNumber"
                                        fullWidth
                                        disabled
                                        variant="outlined"
                                        size="small"
                                        value={formatPhoneNumber(location?.state?.phoneNumber)}
                                    />
                                </Box>
                            </Grid2>
                            <Grid2 sx={{marginTop: "1rem"}}>
                                <Typography
                                    className="form-label required"
                                    sx={{
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        fontFamily: "poppins!important",
                                    }}
                                    >
                                    Address
                                </Typography>
                                <Grid2>
                                    <TextField
                                        sx={{
                                            "& .MuiInputBase-input.Mui-disabled": {
                                                WebkitTextFillColor: "#000000",
                                            },
                                        }}
                                        name="street"
                                        fullWidth
                                        variant="outlined"
                                        autoComplete="off"
                                        size="small"
                                        placeholder="Enter Address"
                                        onChange={(e) =>
                                            formik.handleChange({
                                                target: {
                                                    name: "street",
                                                    value: e?.target?.value?.replace(/[^a-zA-Z0-9\s.,#\-/;'"_&]+/gi, "")?.replace(/\s\s+/g, " ")?.trimStart(),
                                                },
                                            })
                                        }
                                        value={formik.values.street}
                                        disabled={severity === "success"}
                                        slotProps={{ htmlInput: { maxLength: 100 } }}
                                        error={ formik.touched.street && formik.errors.street }
                                    />
                                    {formik.touched.street && formik.errors.street && (
                                        <div style={{ color: "#F04438" }}>{formik.errors.street}</div>
                                    )}
                                </Grid2>
                            </Grid2>
                            <Grid2 sx={{marginTop: '1rem'}}>
                                <Typography
                                    className="form-label required"
                                    sx={{   
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        fontFamily: "poppins!important",
                                    }}
                                >
                                    State
                                </Typography>
                                <FormControl fullWidth size="small" variant="outlined">
                                    <Select
                                        name="state"
                                        sx={{
                                            "& .MuiInputBase-input.Mui-disabled": {
                                                WebkitTextFillColor: "#000000",
                                            },
                                        }}
                                        value={formik.values.state}
                                        onOpen={() => {
                                            setStateSearchTerm("");
                                        }}
                                        onChange={(event) => {
                                            formik.handleChange(event);
                                            handleStateChange(
                                            event.target?.value
                                                ?.replace(/[^a-zA-Z ]+/gi, "")
                                                ?.replace(/\s\s+/g, " ")?.trimStart()
                                            );
                                        }}
                                        MenuProps={{autoFocus: false}}
                                        disabled={severity === "success"}
                                        displayEmpty
                                        renderValue={(selected) =>
                                            selected ? (
                                            selected
                                            ) : (
                                            <span style={{ color: "#A6ADB7" }}>Select state</span>
                                            )
                                        }
                                        error={ formik.touched.state && formik.errors.state}
                                    >
                                    <MenuItem
                                        className="dropdown-search"
                                        disableRipple
                                        sx={{ background: "transparent" }}
                                        value={formik.values.state}
                                    >
                                        <TextField
                                            placeholder="Search state"
                                            size="small"
                                            autoComplete="off"
                                            sx={{ 
                                                outline: "none", 
                                                border: "none",
                                                "& fieldset": { border: 'none' },
                                            }}
                                            fullWidth
                                            slotProps={{htmlInput: {maxLength: 30}}}
                                            value={stateSearchTerm}
                                            onChange={handleStateSearchChange}
                                            autoFocus
                                            onClick={(event) => event.stopPropagation()}
                                            onKeyDown={(event) => {
                                                if (event.key !== "Escape") {
                                                event.stopPropagation();
                                                }
                                            }}
                                        />
                                    </MenuItem>
                                    {filteredStates?.length > 0 ? (
                                        filteredStates?.map((state) => (
                                        <MenuItem key={state.state} value={state.state}>
                                            {state.state}
                                        </MenuItem>
                                        ))
                                    ) : filteredStates?.length === 0 && formik.values?.state ? (
                                        <MenuItem value={formik.values?.state}>
                                            No results found
                                        </MenuItem>
                                    ) : (
                                        <MenuItem disabled>No results found</MenuItem>
                                    )}
                                    </Select>
                                </FormControl>
                                {formik.touched.state && formik.errors.state && (
                                    <div style={{ color: "#F04438" }}>{formik.errors.state}</div>
                                )}
                            </Grid2>
                            <Grid2 sx={{marginTop: '1rem'}}>
                                <Typography
                                    className="form-label required"
                                    sx={{
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    fontFamily: "poppins!important",
                                    }}
                                >
                                    City
                                </Typography>
                                <FormControl fullWidth size="small" variant="outlined">
                                    <Select
                                        name="city"
                                        value={formik.values?.city}
                                        MenuProps={{autoFocus: false}}
                                        onChange={(event) => {
                                            formik.handleChange(event);
                                            handleCityChange(
                                                formik.values?.state,
                                                event.target?.value
                                                    ?.replace(/[^a-zA-Z ]+/gi, "")
                                                    ?.replace(/\s\s+/g, " ")?.trimStart()
                                            );
                                        }}
                                        sx={{
                                            "&.MuiOutlinedInput-root.Mui-disabled": {
                                                "& fieldset": {
                                                    borderColor: (formik.touched.city && formik.errors.city) ? "red" : "#c4c4c4"
                                                },
                                            },
                                            "& .MuiInputBase-input.Mui-disabled": {
                                                WebkitTextFillColor: formik.values?.city && "#000000"
                                            },
                                        }}
                                        disabled={!formik.values?.state || severity === "success"}
                                        displayEmpty
                                        onOpen={() => {
                                            setCitySearchTerm("");
                                        }}
                                        renderValue={(selected) =>
                                            selected ? (
                                            selected
                                            ) : (
                                            <span style={{ color: "#A6ADB7" }}>Select city</span>
                                            )
                                        }
                                        error={formik.touched.city && formik.errors.city}
                                    >
                                    {formik.values?.state && (
                                        <MenuItem
                                            className="dropdown-search"
                                            disableRipple
                                            sx={{ background: "transparent" }}
                                            value={formik.values?.city}
                                        >
                                        <TextField
                                            placeholder="Search City"
                                            size="small"
                                            autoComplete="off"
                                            slotProps={{htmlInput: {maxLength: 30}}}
                                            sx={{ 
                                                outline: "none", 
                                                border: "none",
                                                "& fieldset": { border: 'none' },
                                            }}
                                            fullWidth
                                            value={citySearchTerm}
                                            onChange={handleCitySearchChange}
                                            autoFocus
                                            onClick={(event) => event.stopPropagation()}
                                            onKeyDown={(event) => {
                                                if (event.key !== "Escape") {
                                                    event.stopPropagation();
                                                }
                                            }}
                                        />
                                        </MenuItem>
                                    )}
                                    {filteredCities?.length > 0 && formik.values?.state ? (
                                        filteredCities?.map((city) => (
                                        <MenuItem key={city} value={city}>
                                            {city}
                                        </MenuItem>
                                        ))
                                    ) : filteredCities?.length === 0 && formik.values?.city ? (
                                        <MenuItem value={formik.values?.city}>
                                            No results found
                                        </MenuItem>
                                    ) : (
                                        <MenuItem disabled>No results found</MenuItem>
                                    )}
                                    </Select>
                                </FormControl>
                                {formik.touched.city && formik.errors.city && (
                                    <div style={{ color: "#F04438" }}>{formik.errors.city}</div>
                                )}
                            </Grid2>
                            <Grid2 sx={{marginTop: "1rem"}}>
                                <Typography
                                    className="form-label required"
                                    sx={{
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    fontFamily: "poppins!important",
                                    }}
                                >
                                    Zipcode
                                </Typography>
                                <FormControl fullWidth size="small" variant="outlined">
                                    <Select
                                        name="zipCode"
                                        value={formik.values?.zipCode}
                                        MenuProps={{autoFocus: false}}
                                        onChange={(event) => {
                                            formik.handleChange(event);
                                            formik.setFieldTouched("zipCode", false);
                                        }}
                                        onOpen={() => {
                                            setZipcodeSearchTerm("");
                                        }}
                                        sx={{
                                            "&.MuiOutlinedInput-root.Mui-disabled": {
                                            "& fieldset": {
                                                borderColor: (formik.touched.zipCode && formik.errors.zipCode) ? "red" : "#c4c4c4"
                                            },
                                            },
                                            "& .MuiInputBase-input.Mui-disabled": {
                                                WebkitTextFillColor: formik.values?.zipCode && "#000000",
                                            },
                                        }}
                                        disabled={!formik.values?.state || !formik.values?.city || severity === "success"}
                                        displayEmpty
                                        renderValue={(selected) =>
                                            selected ? (
                                            selected
                                            ) : (
                                            <span style={{ color: "#A6ADB7" }}>Select zipcode</span>
                                            )
                                        }
                                        error={ formik.touched.zipCode && formik.errors.zipCode}
                                    >
                                    {(
                                        <MenuItem
                                        className="dropdown-search"
                                        disableRipple
                                        sx={{ background: "transparent" }}
                                        value={formik.values?.zipCode}
                                        >
                                        <TextField
                                            placeholder="Search Zipcode"
                                            size="small"
                                            autoComplete="off"
                                            slotProps={{htmlInput: {maxLength: 30}}}
                                            sx={{ 
                                                outline: "none", 
                                                border: "none",
                                                "& fieldset": { border: 'none' },
                                            }}
                                            fullWidth
                                            value={zipcodeSearchTerm}
                                            onChange={handleZipcodeSearchChange}
                                            autoFocus
                                            onClick={(event) => event.stopPropagation()}
                                            onKeyDown={(event) => {
                                            if (event.key !== "Escape") {
                                                event.stopPropagation();
                                            }
                                            }} 
                                        />
                                        </MenuItem>
                                    )}
                                    {formik.values?.city ? (
                                        filteredZipcodes?.map((zipCode) => (
                                        <MenuItem key={zipCode} value={zipCode}>
                                            {zipCode}
                                        </MenuItem>
                                        ))
                                    ) : filteredZipcodes?.length === 0 && formik.values?.zipCode ? (
                                        <MenuItem value={formik.values?.zipCode}>
                                            No results found
                                        </MenuItem>
                                    ) : (
                                        <MenuItem disabled>No results found</MenuItem>
                                    )}
                                    </Select>
                                </FormControl>
                                {formik.touched.zipCode && formik.errors.zipCode && (
                                    <div style={{ color: "#F04438" }}>{formik.errors.zipCode}</div>
                                )}
                            </Grid2>
                        </Box>
                        <Button
                            style={{
                                textTransform: "none",
                                borderRadius: "8px",
                                backgroundColor: "#0C68F4",
                                marginTop: "14px"
                            }}
                            variant="contained"
                            color="primary"
                            onClick={formik.handleSubmit}
                            disabled={severity === "success"}
                            >
                            Complete Profile
                        </Button>
                    </Box>
                </Box>
            </Grid2>
            <AlertMessage
                open={open}
                handleClose={handleClose}
                message={message}
                severity={severity}
            />
        </Stack>
    )
}

export default CompleteMobileProfile;